import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import AsideBar from "./Components/Shared/AsideBar/AsideBar";
import Footer from "./Components/Shared/Footer";
import Header from './Components/Shared/Header'
import About from "./Pages/About/About";
import Home from "./Pages/Home/Home/Home";
import Offers from "./Pages/SpecialDeals/Offers/Offers";
import './App.css'
import CartPopUp from "./Components/Shared/CartPopUp";
import MobileBottomNav from "./Components/Shared/MobileBottomNav";
import RightSiderbar from "./Components/Shared/AsideBar/RightSiderbar";
import { fetchProducts } from "./redux/slice/productslice";
import { useDispatch } from "react-redux";
import Search from "./Pages/searchPage/Search";



function App() {
  const [cat, setCate] = useState(true)
  const [right, setRight] = useState(false)


  const dispatch = useDispatch()

  useEffect(() => {
    if (window.screen.width < 768) {
      setCate(false)
    }


    dispatch(fetchProducts())

  }, [dispatch])



  return (
    <div>
      <Header setCate={setCate} cat={cat} />
      <div className="flex relative">
        <AsideBar cat={cat}></AsideBar>
        <div className={`fixed right-0 top-0 overflow-y-scroll h-screen z1 ${right ? "flex" : "flex-none"} ${cat ? "width22 transition-all" : "width12 transition-all "}`}>
          <div className={`${right && "-width320"} `}>

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/search:text" element={<Search />} />
            </Routes>
            <Footer />

            <CartPopUp setRight={setRight} right={right} />
            <MobileBottomNav setRight={setRight} right={right} />
          </div>
          <div className={`${right ? "width320 " : "translate-x-full transition-transform ease-linear z-50 duration-300"}  fixed right-0 top-0 bottom-0 bg-gray-300 `}>
            <RightSiderbar right={right} setRight={setRight} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
